import { postAnalyticsEventSimple, postAnalyticsEvent } from './common';

const TOOK_TICKET = 'FE_ATTEMPT_TAKE_TICKET';
const SIMPLR_CATEGORY_SELECTED = 'SIMPLR_CATEGORY_SELECTED';
const TAG_PICKER_OPENED_ON_TAKE = 'TAG_PICKER_OPENED_ON_TAKE';
const TAG_PICKER_OPENED_ON_TEST_TAG = 'TAG_PICKER_OPENED_ON_TEST_TAG';
const PARTNER_TAGGING_POPUP_TRIGGERED = 'PARTNER_TAGGING_POPUP_TRIGGERED';
const SMB_CATEGORIES_LOADED_VALUE_CHANGE = 'SMB_CATEGORIES_LOADED_VALUE_CHANGE';
const ESCALATED_TICKET = 'FE_ATTEMPT_ESCALATE_TICKET';
const TICKET_REASSIGNED = 'TICKET_REASSIGNED';
const TICKET_ESCALATED_WITH_WRONG_EXPERT_A_RESPONSE = 'TICKET_ESCALATED_WITH_WRONG_EXPERT_A_RESPONSE';
const TICKET_ESCALATED_WITH_CORRECT_EXPERT_A_RESPONSE = 'TICKET_ESCALATED_WITH_CORRECT_EXPERT_A_RESPONSE';
const TICKET_RESOLVED_WITH_CORRECT_EXPERT_A_RESPONSE = 'TICKET_RESOLVED_WITH_CORRECT_EXPERT_A_RESPONSE';
const TICKET_RESOLVED_WITH_WRONG_EXPERT_A_RESPONSE = 'TICKET_RESOLVED_WITH_WRONG_EXPERT_A_RESPONSE';
const TICKET_SWITCH_WHILE_FETCHING_SMB_CATEGORIES = 'TICKET_SWITCH_WHILE_FETCHING_SMB_CATEGORIES';
const ERROR_FETCHING_SMB_CATEGORIES = 'ERROR_FETCHING_SMB_CATEGORIES';
const NO_MAPPING_FOR_SIMPLR_TAG = 'NO_MAPPING_FOR_SIMPLR_TAG';
const ABORTED_NAME_OVERRIDE = 'ABORTED_NAME_OVERRIDE';
const BLOCKED_NAME_OVERRIDE = 'BLOCKED_NAME_OVERRIDE';

export const TICKET_ACTION_SOURCES = {
  LIVE_CHAT_POPUP: 'LIVE_CHAT_POPUP',
  TAG_PICKER: 'TAG_PICKER',
  NOMINATED_TAB: 'NOMINATED_TAB',
  ALL_TICKET_COMPONENT: 'ALL_TICKET_COMPONENT',
};

// TODO: Add existing mixpanel events here

export const trackTakeTicket = async (source) => {
  const params = {
    source,
  };
  await postAnalyticsEventSimple(TOOK_TICKET, params);
};

export const trackSimplrTagSelected = async (selectedTag, recommendedMLTags, multiIntentClassification) => {
  const userSelectedRecommendedTag = recommendedMLTags.includes(selectedTag);
  const params = {
    userSelectedRecommendedTag,
    selectedTag,
    recommendedMLTags,
    multiIntentClassification,
  };

  await postAnalyticsEventSimple(SIMPLR_CATEGORY_SELECTED, params);
};

export const trackTagPickerOpenedOnTake = async (source) => {
  const params = {
    source,
  };
  await postAnalyticsEventSimple(TAG_PICKER_OPENED_ON_TAKE, params);
};

export const trackTagPickerOpenedOnTestTag = async (source) => {
  const params = {
    source,
  };
  await postAnalyticsEventSimple(TAG_PICKER_OPENED_ON_TEST_TAG, params);
};

export const trackPartnerTaggingPopupTriggered = async (conversationId) => {
  const params = {
    conversationId,
  };
  await postAnalyticsEventSimple(PARTNER_TAGGING_POPUP_TRIGGERED, params);
};

export const trackSmbCategoriesLoadedValueChange = async (params) => {
  await postAnalyticsEventSimple(SMB_CATEGORIES_LOADED_VALUE_CHANGE, params);
};

export const trackTicketSwitchWhileFetchingSmbCategories = async (params) => {
  await postAnalyticsEventSimple(TICKET_SWITCH_WHILE_FETCHING_SMB_CATEGORIES, params);
};

export const trackErrorFetchingSmbCategories = async (ticket, err) => {
  const params = {
    err,
    ticket,
  };
  await postAnalyticsEventSimple(ERROR_FETCHING_SMB_CATEGORIES, params);
};

export const trackEscalatedTicket = async (message, ticket = null) => {
  const params = {
    message,
  };
  let parsePointers;
  if (ticket) {
    parsePointers = {
      conversationPtr: ticket.ticketId,
      simplrAccountPtr: ticket.simplrAccountPtrId,
    };
  }

  await postAnalyticsEvent(ESCALATED_TICKET, parsePointers, params);
};

export const trackTicketReassigned = async (previouslyAssignedExpertId) => {
  const params = {
    previouslyAssignedExpertId,
  };
  await postAnalyticsEventSimple(TICKET_REASSIGNED, params);
};

export const trackResolvedTicketWithWrongExpertAResponse = async () => {
  await postAnalyticsEventSimple(TICKET_RESOLVED_WITH_WRONG_EXPERT_A_RESPONSE);
};

export const trackResolvedTicketWithCorrectExpertAResponse = async () => {
  await postAnalyticsEventSimple(TICKET_RESOLVED_WITH_CORRECT_EXPERT_A_RESPONSE);
};

export const trackEscalatedTicketWithWrongExpertAResponse = async () => {
  await postAnalyticsEventSimple(TICKET_ESCALATED_WITH_WRONG_EXPERT_A_RESPONSE);
};

export const trackEscalatedTicketWithCorrectExpertAResponse = async () => {
  await postAnalyticsEventSimple(TICKET_ESCALATED_WITH_CORRECT_EXPERT_A_RESPONSE);
};

export const trackNoMappingForSimplrTag = async (conversationId, selectedSimplrTag) => {
  const params = {
    conversationId,
    selectedSimplrTag,
  };
  await postAnalyticsEventSimple(NO_MAPPING_FOR_SIMPLR_TAG, params);
};

export const trackAbortedNameOverride = async () => {
  await postAnalyticsEventSimple(ABORTED_NAME_OVERRIDE);
};

export const trackBlockedNameOverride = async (names) => {
  const params = {
    names,
  };
  await postAnalyticsEventSimple(BLOCKED_NAME_OVERRIDE, params);
};
